package game

enum class Talents(
    val branch: TalentBranches,
    val upgradeCount: Int,
    val talentSelectionRule: TalentSelectionRule
) {

    // TRAPS
    TRAP(
        branch = TalentBranches.TRAPS,
        upgradeCount = 5,
        talentSelectionRule = ALWAYS_ACCEPT
    ),
    TRAP_STEALTH(TalentBranches.TRAPS, 3, { t -> (TRAP hasCount 3).invoke(t) }),
    FAKE_TRAP(TalentBranches.TRAPS, 3, ALWAYS_ACCEPT),
    MORE_TRAPS(TalentBranches.TRAPS, 2, ALWAYS_ACCEPT),
    TRAP_IMPULSE_EXPLOSION(TalentBranches.TRAPS, 2, ALWAYS_ACCEPT),

    // SURVIVAL
    ACCELERATION(TalentBranches.SURVIVAL, 1, ALWAYS_ACCEPT),
    LITE_FOOT(TalentBranches.SURVIVAL, 1, ALWAYS_ACCEPT),
    DOUBLE_JUMP(TalentBranches.SURVIVAL, 1, ALWAYS_ACCEPT),
    DODGE(TalentBranches.SURVIVAL, 1, ALWAYS_ACCEPT),
    HOT_BLOOD(TalentBranches.SURVIVAL, 1, ALWAYS_ACCEPT),

    // MAGIC
    FROST_NOVA(TalentBranches.MAGIC, 1, ALWAYS_ACCEPT),
    FROST_NOVA_COVERAGE_AREA(TalentBranches.MAGIC, 1, ALWAYS_ACCEPT),
    DEEP_FREEZE(TalentBranches.MAGIC, 1, ALWAYS_ACCEPT),
    FROST_BOLT(TalentBranches.MAGIC, 1, ALWAYS_ACCEPT),
    FROST_BOLT_2_HANDS(TalentBranches.MAGIC, 1, ALWAYS_ACCEPT)

}
